import styled from "styled-components";

export const SideMenuCrossBrandsListItemBox = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex: 1;
  text-align: center;
  font-size: 1.2rem;
  line-height: 1;
  margin-right: 1rem;
  padding: 1rem;
  color: ${props => props.theme.colors.textMiddleDark};
  border: 2px solid ${props => props.theme.colors.boxBorder};
  border-radius: ${props => props.theme.layout.border.radius};
  &:last-of-type {
    margin-right: 0;
  }
`